import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpModalComponent } from './help-modal.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [HelpModalComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [HelpModalComponent],
  entryComponents: [HelpModalComponent]
})

export class HelpModalModule { }